// Libs
import classNames from 'classnames/bind';
import { Box, Grid2, Link, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
// Components, Layouts, Pages
import { EmployeeDetailModal } from '~/components/module/employee';
import { BaseLabelValueField, BaseStatus, Loading } from '~/components/common';
// Others
import { ITaskDetail } from '~/utils/interface/task';
import { EMPTY_STRING } from '~/utils/constants/common';
import { formatDate, getFullName } from '~/utils/helper/common';
import { DateFormatEnum } from '~/utils/enum/common';
import { useAppDispatch } from '~/utils/redux/hooks';
import { getTaskDetail } from '~/thunks/task/taskThunk';
// Styles, images, icons
import styles from './TaskInformation.module.scss';

type Props = {};

const cx = classNames.bind(styles);

const TaskInformation = (props: Props) => {
  //#region Destructuring Props

  //#endregion Destructuring Props

  //#region Declare Hook
  const { t } = useTranslation(['admin/task']);
  const dispatch = useAppDispatch();
  const { id: taskId } = useParams();
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  const [taskDetail, setTaskDetail] = useState<ITaskDetail>();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isShowEmployeeDetail, setIsShowEmployeeDetail] = useState<boolean>(false);
  const [employeeId, setEmployeeId] = useState<string>();
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  useEffect(() => {
    if (!taskId) return;

    handleGetTaskDetail(taskId);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [taskId]);
  //#endregion Implement Hook

  //#region Handle Function
  const handleGetTaskDetail = (taskId: string) => {
    setIsLoading(true);

    dispatch(getTaskDetail(taskId))
      .unwrap()
      .then((res) => {
        setTaskDetail(res?.data);
      })
      .catch((error) => {})
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handleOpenEmployeeDetail = () => {
    setEmployeeId(taskDetail?.assignee?.id);
    setIsShowEmployeeDetail(true);
  };

  const handleCloseEmployeeDetail = () => {
    setIsShowEmployeeDetail(false);
    setEmployeeId(EMPTY_STRING);
  };
  //#endregion Handle Function

  return (
    <Box component={'div'} id='taskInformationPage' className={cx('container')}>
      <Grid2 container spacing={'24px'}>
        <Grid2 size={12}>
          <BaseLabelValueField
            label={t('task_information_label_name')}
            value={taskDetail?.title || EMPTY_STRING}
          />

          <BaseLabelValueField
            label={t('task_information_label_employee')}
            value={
              <Link onClick={handleOpenEmployeeDetail} component={'button'}>
                {getFullName({ ...taskDetail?.assignee })}
              </Link>
            }
          />

          <BaseLabelValueField
            label={t('task_information_label_due_date')}
            value={
              taskDetail?.dueDate ? formatDate(taskDetail?.dueDate, DateFormatEnum.DD_MMM_YYYY) : EMPTY_STRING
            }
          />

          <BaseLabelValueField
            label={t('task_information_label_description')}
            value={
              <Typography className={cx('textDescription')}>
                {taskDetail?.description || EMPTY_STRING}
              </Typography>
            }
          />

          <BaseLabelValueField
            label={t('task_information_label_status')}
            value={taskDetail?.status ? <BaseStatus label={taskDetail?.status} /> : EMPTY_STRING}
          />
        </Grid2>
      </Grid2>

      <EmployeeDetailModal
        isOpen={isShowEmployeeDetail}
        onClose={handleCloseEmployeeDetail}
        employeeId={employeeId as string}
      />

      {isLoading && <Loading />}
    </Box>
  );
};

export default TaskInformation;
